import { render, staticRenderFns } from "./GoodsSupplier.vue?vue&type=template&id=486903fa&scoped=true"
import script from "./GoodsSupplier.vue?vue&type=script&lang=js"
export * from "./GoodsSupplier.vue?vue&type=script&lang=js"
import style0 from "./GoodsSupplier.vue?vue&type=style&index=0&id=486903fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486903fa",
  null
  
)

export default component.exports